// src/services/movimientoService.js
import axios from "axios";

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const API_URL_BASE = `${API_BASE}/api/movtos`;

export const obtenerCartera = async (empresaId) => {
    const endpoint = `${API_URL_BASE}/cartera`;
    
    // 1. Ejecutar la llamada Axios
    const resp = await axios.get(endpoint, {
        params: {
            empresaId,
        }
    });

    // 2. 🚨 CLAVE: Devolver el arreglo de datos desde la respuesta de Axios 🚨
    //    Si tu API devuelve el arreglo directamente, usa resp.data.
    //    Si lo envuelve en una propiedad (ej. { Data: [...] }), úsala.
    
    // Por lo que veo en tu controlador de C#, regresa un `ActionResult<IEnumerable<MovtoCarteraDto>>`
    // que generalmente devuelve el array directamente como `resp.data`.
    return resp.data; 
};